<template>
  <div class="live-subtitle" :class="{show: !showText}">{{text}}</div>
  
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import * as signalR from "@microsoft/signalr";
export default {
  name: "live-subtitle",
  props: {
    code: {
      type: String,
      default: ""
    },
    langType: {
      type: String,
      default: "zh"
    }
  },
  computed: {
    langOpt() {
      return this.$store.getters["getLangOpt"];
    }
  },
  ...mapGetters({
  }),
  data() {  
    return {
      hub: null,
      opt: null,
      text: "",
      showText: true,
      open: false,
      reload: false // 有连接时先关闭后重启
    };
  },
  created() {},
  methods: {
    ...mapActions({
      getLangSubtitle: "getLangSubtitle"
    }),
    async init() {
      this.opt = null;
      this.text = "";
      this.open = false;
      const req = {
        code: this.code,
        lang: this.langType,
        type: "1"
      };
      const bool = await this.getLangSubtitle(req);
      this.opt = bool;
      console.log("字幕授权信息：", bool);
      if (this.hub) {
        this.reload = true;
        if (this.langType === "zh") {
          this.showText=false;
          this.reload = false;
        }
        this.closeSocket();
      } else {
        this.getHub();
      }
    },
    //建立连接
    getHub() {
      const url =
        "wss://api.enewie.com/tapi/live_ws?code=" +
        this.opt.code +
        "&lang=" +
        this.opt.lang +
        "&type=" +
        this.opt.type +
        "&t=" +
        this.opt.t +
        "&key=" +
        this.opt.key +
        "&sign=" +
        this.opt.sign;
      const that = this;

      if (this.langType === "zh") {
        
        this.reduction();
        return;
      }
      console.log(this.opt);
      if('WebSocket' in window){
        this.hub = new WebSocket(url);   //'wss://echo.websocket.org/'
      }else{
        this.$toast.fail('您的浏览器不支持websocket')
        return 
      }
      this.hub.onopen=(res)=>{
        console.log('字幕链接成功',res)
        this.showText = true;
        this.open = true;
      }
      this.hub.onerror =(res)=>{
        console.info("字幕连接报错");
        console.error("字幕连接报错",res);
      }
      this.hub.onmessage=(res)=>{
        let data = JSON.parse(res.data);
        // console.info("字幕消息",data);
        if (data.type === 1) {
          setTimeout(() => {
            if (!this.showText) return;
            this.text = data.text;
          }, 100);
        } else {
          console.error(data.text);
        }
        
      }
      this.hub.onclose  = (res)=>{
        this.showText = false;
        console.log('字幕断开连接',res);
        this.reduction();
        if (this.reload && res.code === 1000) {
            this.getHub();
            console.log("字幕连接重启~~~~~~~~~~~~~~~~~");
          }
        this.reload=false
      }
      // 连接回调
      // this.hub.onClose(res => {
      //   console.info("连接关闭~~~~~~~~~~~~~~~~~~", res);
      //   this.showText = false;
      //   that.reduction();
      //   if (that.reload && res.code === 1000) {
      //     that.getHub();
      //     console.log("连接重启~~~~~~~~~~~~~~~~~");
      //   }
      //   that.reload = false;
      // });
      // this.hub.onError(res => {
      //   console.info("连接报错");
      //   console.error(res);
      // });
      // this.hub.onMessage(res => {
      //   var data = JSON.parse(res.data);
      //   if (data.type === 1) {
      //     setTimeout(() => {
      //       if (!this.showText) return;
      //       this.text = data.text;
      //     }, 100);
      //   } else {
      //     console.error(data.text);
      //   }
      //   console.info(data);
      // });
      // this.hub.onOpen(res => {
      //   console.info("连接识别");
      //   console.log(res);
      //   that.showText = true;
      //   that.open = true;
      // });
    },
    closeSocket() {
      if (!this.hub) return;
      this.hub.close();
    },
    reduction() {
      this.hub = null;
      this.text = "";
      this.open = false;
      setTimeout(() => {
        this.text = "";
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
.live-subtitle {
  line-height: 0.46rem;
  min-height:1.6rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  padding:0 1rem 0 0.5rem;
  width: 100%;
  font-size: 0.26rem;
  background: rgba($color: #000, $alpha: 0.65);
  color: #fff;
  &.show {
    opacity: 0;
  }
}
</style>